// Fixed filter options for the Product Sales pages.

// FY 2024-25 (first orders) up to the current financial year, newest first
export const getFyOptions = () => {
  const now = new Date();
  const current = now.getMonth() >= 3 ? now.getFullYear() : now.getFullYear() - 1;
  const options = [];
  for (let y = current; y >= 2024; y--) {
    const value = `${y}-${String(y + 1).slice(-2)}`;
    options.push({ value, label: `FY ${value}` });
  }
  return options;
};

export const MONTH_OPTIONS = [
  { value: "all", label: "All months" },
  { value: "Apr", label: "April" },
  { value: "May", label: "May" },
  { value: "Jun", label: "June" },
  { value: "Jul", label: "July" },
  { value: "Aug", label: "August" },
  { value: "Sep", label: "September" },
  { value: "Oct", label: "October" },
  { value: "Nov", label: "November" },
  { value: "Dec", label: "December" },
  { value: "Jan", label: "January" },
  { value: "Feb", label: "February" },
  { value: "Mar", label: "March" },
];

// ShopOrder.order_type
export const ORDER_TYPES = [
  { value: "B2B", label: "B2B" },
  { value: "B2C", label: "B2C" },
  { value: "THIRD_PARTY", label: "Third Party" },
];

// ShopOrder.status
export const ORDER_STATUSES = [
  { value: "PENDING", label: "Pending" },
  { value: "CONFIRMED", label: "Confirmed" },
  { value: "IN_PACKAGING", label: "In Packaging" },
  { value: "READY_TO_DISPATCH", label: "Ready to Dispatch" },
  { value: "DISPATCHED", label: "Dispatched" },
  { value: "DELIVERED", label: "Delivered" },
  { value: "CANCELLED", label: "Cancelled" },
  { value: "RETURNED", label: "Returned" },
];

export const ALL_ORDER_TYPES = ORDER_TYPES.map((t) => t.value);

// Query params shared by the list, detail and export APIs (no order_types = all types)
// A picked date range (both ends) replaces FY and month.
export const filterParams = ({ fy, month, dateRange, orderTypes, statuses }) => ({
  ...(dateRange?.start && dateRange?.end ? { start_date: dateRange.start, end_date: dateRange.end } : { fy, month }),
  statuses: statuses.join(","),
  ...(orderTypes.length < ALL_ORDER_TYPES.length && { order_types: orderTypes.join(",") }),
});

// Quick groups on Product Sales: ticking one picks its products for the combined view.
// Add a group here (name -> SKUs); the backend just adds up whatever SKUs it is sent.
export const PRODUCT_GROUPS = [
  {
    name: "Zatka Machine",
    skus: ["RA-SFE-8K", "RA-SFE-10K", "RA-SFE-12K", "RA-SFE-15K", "RA-SFE-18K", "RA-DSFE-18K", "RA-DRFE-18K", "RA-DPFE-18K"],
  },
  {
    name: "Double Motor Sprayer",
    skus: [
      "FB-BSD-001", "FB-BSD-002", "RA-BSD-1212", "RA-BSD-1214", "RA-BSD-1216", "RA-BSD-1218", "RA-BSD-1220",
      "RA-BSDL-1212", "RA-BSDL-1216", "RA-BSDL-1220", "BS Double Motor 12-20",
    ],
  },
];

// The group whose SKUs are exactly these (any order), if any
export const groupForSkus = (skus) =>
  PRODUCT_GROUPS.find((g) => g.skus.length === skus.length && g.skus.every((s) => skus.includes(s)));
